import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  DialogActions,
} from '@mui/material';

import VideoCapture from './BarcodeScanner';
import { useTranslation } from 'react-i18next';

const BarcodeScannerModal = ({
  open,
  onClose,
  onCodeScanned,
  processing = false,
}) => {
  const { t } = useTranslation(['button', 'title']);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ fontSize: 16 }}>
        {t('barcode_code', { ns: 'title' })}
      </DialogTitle>
      <DialogContent>
        <VideoCapture onDetected={onCodeScanned} processing={processing} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          {t('close', { ns: 'button' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default BarcodeScannerModal;
